import React, { createContext, useEffect, useState } from "react";

import FoundryPhysicalProduct from "../lib/foundry_client/models/FoundryPhysicalProduct";

export const PhysicalProductsContext = createContext({
  physicalProducts: [] as FoundryPhysicalProduct[],
  setPhysicalProducts: null as React.Dispatch<
    React.SetStateAction<FoundryPhysicalProduct[]>
  > | null,
});

const PhysicalProductsProvider = (props) => {
  const [physicalProducts, setPhysicalProducts] = useState(
    [] as FoundryPhysicalProduct[]
  );

  return (
    <PhysicalProductsContext.Provider
      value={{
        physicalProducts,
        setPhysicalProducts,
      }}
    >
      {props.children}
    </PhysicalProductsContext.Provider>
  );
};

export default PhysicalProductsProvider;
